import { render, staticRenderFns } from "./VFormSelect.vue?vue&type=template&id=3c0cd6ea&"
import script from "./VFormSelect.vue?vue&type=script&lang=js&"
export * from "./VFormSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports